module.exports = __webpack_public_path__ + "static/media/bs.9f8a4eae.svg";